// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1vbr0","right":"Footer_right__1-vh5","buttons":"Footer_buttons__30WfC"};